import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import { lireJour, sauverJour } from '../../db/repo'
import { shiftDayKey } from '../../domain/time'
import { Carte, Champ, Curseur, Entete, Puce } from '../composants'

const FMT = new Intl.DateTimeFormat('fr-FR', {
  weekday: 'long',
  day: 'numeric',
  month: 'long',
  year: 'numeric',
})

export function PageJour() {
  const { date } = useParams()
  const jourCle = date ?? ''

  const [stress, setStress] = useState<number | null>(null)
  const [heures, setHeures] = useState<number | null>(null)
  const [qualite, setQualite] = useState<number | null>(null)
  const [notes, setNotes] = useState('')
  const [enregistre, setEnregistre] = useState(false)

  useEffect(() => {
    if (!jourCle) return
    void lireJour(jourCle).then((j) => {
      setStress(j?.stress ?? null)
      setHeures(j?.heuresSommeil ?? null)
      setQualite(j?.qualiteSommeil ?? null)
      setNotes(j?.notes ?? '')
      setEnregistre(Boolean(j))
    })
  }, [jourCle])

  const sauver = async (patch?: Partial<{ stress: number; heures: number; qualite: number; notes: string }>) => {
    const s = patch?.stress ?? stress
    const h = patch?.heures ?? heures
    const q = patch?.qualite ?? qualite
    const n = patch?.notes ?? notes
    await sauverJour({
      date: jourCle,
      stress: s,
      heuresSommeil: h,
      qualiteSommeil: q,
      ...(n.trim() ? { notes: n.trim() } : {}),
    })
    setEnregistre(true)
  }

  return (
    <>
      <Entete
        titre="Journal du jour"
        sousTitre={jourCle ? FMT.format(new Date(`${jourCle}T12:00:00`)) : ''}
        retour
        action={enregistre ? <Puce ton="ok">Renseigne</Puce> : <Puce ton="alerte">Vide</Puce>}
      />

      <main className="contenu">
        <Carte titre="Stress & sommeil">
          <p className="doux" style={{ marginBottom: 12 }}>
            Le stress et le manque de sommeil déclenchent des symptômes de SCI indépendamment de
            l'alimentation. Les renseigner permet à l'analyse de vérifier qu'une piste alimentaire
            tient aussi bien les jours calmes que les jours difficiles.
          </p>

          <div className="pile">
            <Curseur
              label="Stress"
              valeur={stress ?? 0}
              onChange={(v) => {
                setStress(v)
                void sauver({ stress: v })
              }}
              suffixe="/10"
            />
            <Curseur
              label="Qualité du sommeil"
              valeur={qualite ?? 0}
              onChange={(v) => {
                setQualite(v)
                void sauver({ qualite: v })
              }}
              suffixe="/10"
            />
            <Curseur
              label="Heures de sommeil"
              valeur={heures ?? 7}
              onChange={(v) => {
                setHeures(v)
                void sauver({ heures: v })
              }}
              min={0}
              max={14}
              pas={0.5}
              suffixe=" h"
            />
          </div>
        </Carte>

        <Carte>
          <Champ label="Notes du jour">
            <textarea
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              onBlur={() => void sauver()}
              placeholder="Événement particulier, médicament, voyage..."
            />
          </Champ>
        </Carte>

        <div className="boutons">
          <a href={`#/jour/${shiftDayKey(jourCle, -1)}`} className="btn grandir">
            Jour précédent
          </a>
          <a href={`#/jour/${shiftDayKey(jourCle, 1)}`} className="btn grandir">
            Jour suivant
          </a>
        </div>
      </main>
    </>
  )
}
